class FaqSearch extends HTMLElement {
    constructor() {
      super();
      this.cachedResults = {};
      this.container = document.querySelector('.doc-grid');
      this.input = document.querySelector('#faq-search');
      this.SearchResults = this.querySelector('[data-predictive-search]');
      this.videoBlocks = this.container.querySelectorAll('[data-block-id]');

      this.sortbyOPtions = this.container.querySelectorAll('.custom-doc-dropdown .sortby_options');
      this.sortbyOPtions.forEach(select => {
        select.addEventListener('change', this.updateSortBy.bind(this));
    });
      this.searchTerm = '';
      
      this.setupEventListeners();
      
    }
  
    
    updateSortBy(event) {
        const selectedValue = event.target.value.toLowerCase().replace(/\s+/g, '-');

        this.videoBlocks.forEach(block => {
            const blockClass = block.className.toLowerCase();
            if (selectedValue === 'all' || blockClass.includes(selectedValue)) {
                block.style.display = '';
            } else {
                block.style.display = 'none';
            }
        });
    }

    /**
     * Bind the events on the search input
     */
    setupEventListeners() {
      if (this.input) {
        this.input.addEventListener('input', Utility.debounce((event) => {
          this.onChange(event);
        }, 500).bind(this))
      }

      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }
  
    /**
     * 
     * @returns Search Query with trim value
     */
    getQuery() {
      return this.input.value.trim();
    }
  
    onChange() {
        const newSearchTerm = this.getQuery();
        this.searchTerm = newSearchTerm;
        this.getSearchResults(this.searchTerm);
    }
  
    /**
     * Trigger Form Submit event
     * @param {*} event 
     */
  
    onFormSubmit(event) {
      event.preventDefault();
    }
  
    
    onFocus() {
      const currentSearchTerm = this.getQuery();
  
      if (!currentSearchTerm.length) return;
  
      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      }else {
        this.getSearchResults(this.searchTerm);
      }
    }
  
    getSearchResults(searchTerm) {
        const faqItems = document.querySelectorAll('.doc-title');
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        let html = '';
      
        if (searchTerm.trim() === '') {
            this.SearchResults.classList.add('d-none');
            faqItems.forEach(item => item.style.display = 'block'); // Show all
            
            return;
        }
      
        const matchingItems = [...faqItems].filter(item => {
          const question = item.querySelector('.doc-title a').textContent.toLowerCase();
          return question.includes(searchTerm.toLowerCase());
        });
        

        faqItems.forEach(item => {
          if (matchingItems.includes(item)) {
            item.style.display = 'block'; // Show matched
          } else {
            item.style.display = 'none'; // Hide unmatched
          }
        });
      
        
        this.SearchResults.classList.remove('d-none');
      
        if (!this.cachedResults[queryKey] && searchTerm.trim() !== '') {
          this.cachedResults[queryKey] = html;
        }
      
        
      }
        
  
    

    /**
     * Show Search results container
     */
    showResults(){
        this.predictiveSearchResults.classList.add('show-results');
    }
}
  
customElements.define('faq-search', FaqSearch);
  